// extracted by mini-css-extract-plugin
export default {"noData":"_2cw77","skeletonWrapper":"_138nm"};